import { useEffect, useLayoutEffect } from 'react';

/** SSR 시 useLayoutEffect 경고 방지 (schedule.js 와 동일) */
const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect;

/** sbs-gnb-m / sbs-gnb-4.0.0 등 GNB 스타일시트 */
const GNB_STYLE_PATTERN = /sbs-gnb/i;

function removeGnbStyles() {
  document.querySelectorAll('link[rel="stylesheet"]').forEach((link) => {
    if (GNB_STYLE_PATTERN.test(link.href || '')) {
      link.remove();
    }
  });
}

function stripWrapGnbClass() {
  const wrap = document.getElementById('wrap');
  if (wrap) {
    wrap.classList.remove('sbs_common_wrap');
  }
}

/** head에 link 추가/삭제가 있을 때만 스캔 */
function affectsStylesheetLinks(mutations) {
  for (const m of mutations) {
    for (const n of m.addedNodes) {
      if (n.nodeType === 1 && n.nodeName === 'LINK') return true;
    }
    for (const n of m.removedNodes) {
      if (n.nodeType === 1 && n.nodeName === 'LINK') return true;
    }
  }
  return false;
}

/**
 * 앱 WebView 전용 라이브 페이지(end·전체편성표): GNB UI/CSS만 제거
 * - GNB JS는 Head에서 로드(공통 GA · __SBSLogModuleDataLayer 수신)
 * - _app #wrap.sbs_common_wrap 클래스·주입된 sbs-gnb 스타일시트 제거
 */
export function useLiveAppPageNoGnb() {
  useIsomorphicLayoutEffect(() => {
    stripWrapGnbClass();
    removeGnbStyles();
  }, []);

  useEffect(() => {
    let rafId = 0;

    const runCleanup = () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        rafId = 0;
        removeGnbStyles();
        stripWrapGnbClass();
      });
    };

    runCleanup();

    const observer = new MutationObserver((mutations) => {
      if (affectsStylesheetLinks(mutations)) {
        runCleanup();
      }
    });
    observer.observe(document.head, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, []);
}
